module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFixNav),
      expression: "showFixNav"
    }],
    staticClass: "nav-fix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-gapless is-mobile"
  }, [(!_vm.isMobile) ? _c('div', {
    staticClass: "column is-half-desktop left"
  }, [_c('a', {
    attrs: {
      "href": "http://www.geekbang.org",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("企业服务")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab column is-half-desktop right"
  }, [_c('div', {
    staticClass: "word"
  }, [_c('span', {
    class: {
      'active': _vm.currentIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.switchItem(0)
      }
    }
  }, [_c('b', [_vm._v("整合营销")])]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.currentIndex === 1
    },
    on: {
      "click": function($event) {
        _vm.switchItem(1)
      }
    }
  }, [_c('b', [_vm._v("培训和咨询")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-703eeb10","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/fixnav/fix.vue
// module id = 461
// module chunks = 1